/** IMPORTANT: This file is auto-generated by eddev. Do not edit. */
import { blockManifestReader } from "eddev/_internal";
import { dynamic } from "eddev/dynamic";
import core from "../../../blocks/_core";

const manifest = {
  "acf/content-callout": dynamic(() => import("../../../blocks/content/callout.tsx"), "blocks/content/callout.tsx"),
  "acf/content-callout-card": dynamic(
    () => import("../../../blocks/content/callout-card.tsx"),
    "blocks/content/callout-card.tsx",
  ),
  "acf/content-callout-left": dynamic(
    () => import("../../../blocks/content/callout-left.tsx"),
    "blocks/content/callout-left.tsx",
  ),
  "acf/content-callout-right": dynamic(
    () => import("../../../blocks/content/callout-right.tsx"),
    "blocks/content/callout-right.tsx",
  ),
  "acf/content-expandable-list": dynamic(
    () => import("../../../blocks/content/expandable-list.tsx"),
    "blocks/content/expandable-list.tsx",
  ),
  "acf/content-expandable-list-item": dynamic(
    () => import("../../../blocks/content/expandable-list-item.tsx"),
    "blocks/content/expandable-list-item.tsx",
  ),
  "acf/content-pull-quote": dynamic(
    () => import("../../../blocks/content/pull-quote.tsx"),
    "blocks/content/pull-quote.tsx",
  ),
  "acf/content-quote-card": dynamic(
    () => import("../../../blocks/content/quote-card.tsx"),
    "blocks/content/quote-card.tsx",
  ),
  "acf/content-quote-carousel": dynamic(
    () => import("../../../blocks/content/quote-carousel.tsx"),
    "blocks/content/quote-carousel.tsx",
  ),
  "acf/content-team-list": dynamic(
    () => import("../../../blocks/content/team-list.tsx"),
    "blocks/content/team-list.tsx",
  ),
  "acf/content-team-list-item": dynamic(
    () => import("../../../blocks/content/team-list-item.tsx"),
    "blocks/content/team-list-item.tsx",
  ),
  "acf/content-team-list-item-body": dynamic(
    () => import("../../../blocks/content/team-list-item-body.tsx"),
    "blocks/content/team-list-item-body.tsx",
  ),
  "acf/film-film-grid": dynamic(() => import("../../../blocks/film/film-grid.tsx"), "blocks/film/film-grid.tsx"),
  "acf/film-film-header": dynamic(() => import("../../../blocks/film/film-header.tsx"), "blocks/film/film-header.tsx"),
  "acf/film-latest-films": dynamic(
    () => import("../../../blocks/film/latest-films.tsx"),
    "blocks/film/latest-films.tsx",
  ),
  "acf/film-now-playing-bar": dynamic(
    () => import("../../../blocks/film/now-playing-bar.tsx"),
    "blocks/film/now-playing-bar.tsx",
  ),
  "acf/film-poster-carousel": dynamic(
    () => import("../../../blocks/film/poster-carousel.tsx"),
    "blocks/film/poster-carousel.tsx",
  ),
  "acf/film-related-films": dynamic(
    () => import("../../../blocks/film/related-films.tsx"),
    "blocks/film/related-films.tsx",
  ),
  "acf/forms-form": dynamic(() => import("../../../blocks/forms/form.tsx"), "blocks/forms/form.tsx"),
  "acf/forms-newsletter": dynamic(() => import("../../../blocks/forms/newsletter.tsx"), "blocks/forms/newsletter.tsx"),
  "acf/forms-newsletter-inner": dynamic(
    () => import("../../../blocks/forms/newsletter-inner.tsx"),
    "blocks/forms/newsletter-inner.tsx",
  ),
  "acf/holding-page-holding-page": dynamic(
    () => import("../../../blocks/holding-page/holding-page.tsx"),
    "blocks/holding-page/holding-page.tsx",
  ),
  "acf/layout-generic-header": dynamic(
    () => import("../../../blocks/layout/generic-header.tsx"),
    "blocks/layout/generic-header.tsx",
  ),
  "acf/layout-narrow-content": dynamic(
    () => import("../../../blocks/layout/narrow-content.tsx"),
    "blocks/layout/narrow-content.tsx",
  ),
  "acf/layout-section": dynamic(() => import("../../../blocks/layout/section.tsx"), "blocks/layout/section.tsx"),
  "acf/layout-spacer": dynamic(() => import("../../../blocks/layout/spacer.tsx"), "blocks/layout/spacer.tsx"),
  "acf/layout-text-and-media": dynamic(
    () => import("../../../blocks/layout/text-and-media.tsx"),
    "blocks/layout/text-and-media.tsx",
  ),
  "acf/layout-text-and-media-inner": dynamic(
    () => import("../../../blocks/layout/text-and-media-inner.tsx"),
    "blocks/layout/text-and-media-inner.tsx",
  ),
  "acf/layout-two-columns": dynamic(
    () => import("../../../blocks/layout/two-columns.tsx"),
    "blocks/layout/two-columns.tsx",
  ),
  "acf/layout-two-columns-left": dynamic(
    () => import("../../../blocks/layout/two-columns-left.tsx"),
    "blocks/layout/two-columns-left.tsx",
  ),
  "acf/layout-two-columns-right": dynamic(
    () => import("../../../blocks/layout/two-columns-right.tsx"),
    "blocks/layout/two-columns-right.tsx",
  ),
  "acf/media-image-gallery": dynamic(
    () => import("../../../blocks/media/image-gallery.tsx"),
    "blocks/media/image-gallery.tsx",
  ),
  "acf/media-inline-media": dynamic(
    () => import("../../../blocks/media/inline-media.tsx"),
    "blocks/media/inline-media.tsx",
  ),
  "acf/media-inline-medias": dynamic(
    () => import("../../../blocks/media/inline-medias.tsx"),
    "blocks/media/inline-medias.tsx",
  ),
  "acf/memberships-become-a-member": dynamic(
    () => import("../../../blocks/memberships/become-a-member.tsx"),
    "blocks/memberships/become-a-member.tsx",
  ),
  "acf/memberships-become-a-member-inner": dynamic(
    () => import("../../../blocks/memberships/become-a-member-inner.tsx"),
    "blocks/memberships/become-a-member-inner.tsx",
  ),
  "acf/memberships-membership-grid": dynamic(
    () => import("../../../blocks/memberships/membership-grid.tsx"),
    "blocks/memberships/membership-grid.tsx",
  ),
  "acf/memberships-membership-grid-group": dynamic(
    () => import("../../../blocks/memberships/membership-grid-group.tsx"),
    "blocks/memberships/membership-grid-group.tsx",
  ),
  "acf/memberships-membership-grid-group-row": dynamic(
    () => import("../../../blocks/memberships/membership-grid-group-row.tsx"),
    "blocks/memberships/membership-grid-group-row.tsx",
  ),
  "acf/memberships-membership-levels": dynamic(
    () => import("../../../blocks/memberships/membership-levels.tsx"),
    "blocks/memberships/membership-levels.tsx",
  ),
  "acf/news-latest-news": dynamic(() => import("../../../blocks/news/latest-news.tsx"), "blocks/news/latest-news.tsx"),
  "acf/news-news-grid": dynamic(() => import("../../../blocks/news/news-grid.tsx"), "blocks/news/news-grid.tsx"),
  "acf/news-news-header": dynamic(() => import("../../../blocks/news/news-header.tsx"), "blocks/news/news-header.tsx"),
  "acf/programs-program-films": dynamic(
    () => import("../../../blocks/programs/program-films.tsx"),
    "blocks/programs/program-films.tsx",
  ),
  "acf/programs-program-header": dynamic(
    () => import("../../../blocks/programs/program-header.tsx"),
    "blocks/programs/program-header.tsx",
  ),
  "acf/programs-program-list": dynamic(
    () => import("../../../blocks/programs/program-list.tsx"),
    "blocks/programs/program-list.tsx",
  ),
  "acf/support-donate": dynamic(() => import("../../../blocks/support/donate.tsx"), "blocks/support/donate.tsx"),
  "acf/support-donate-left": dynamic(
    () => import("../../../blocks/support/donate-left.tsx"),
    "blocks/support/donate-left.tsx",
  ),
  "acf/support-donate-right": dynamic(
    () => import("../../../blocks/support/donate-right.tsx"),
    "blocks/support/donate-right.tsx",
  ),
  "acf/support-presented-by": dynamic(
    () => import("../../../blocks/support/presented-by.tsx"),
    "blocks/support/presented-by.tsx",
  ),
  "acf/support-sponsors": dynamic(() => import("../../../blocks/support/sponsors.tsx"), "blocks/support/sponsors.tsx"),
  ...core,
};

const info = {
  "acf/content-callout": { "slug": "content/callout", "tags": ["#page", "#inline"], "flags": {} },
  "acf/content-callout-card": { "slug": "content/callout-card", "tags": ["#page", "#inline"], "flags": {} },
  "acf/content-callout-left": { "slug": "content/callout-left", "flags": {} },
  "acf/content-callout-right": { "slug": "content/callout-right", "flags": {} },
  "acf/content-expandable-list": { "slug": "content/expandable-list", "tags": ["#page", "#inline"], "flags": {} },
  "acf/content-expandable-list-item": { "slug": "content/expandable-list-item", "flags": {} },
  "acf/content-pull-quote": { "slug": "content/pull-quote", "tags": ["#page", "#inline"], "flags": {} },
  "acf/content-quote-card": { "slug": "content/quote-card", "tags": ["#page", "#inline"], "flags": {} },
  "acf/content-quote-carousel": { "slug": "content/quote-carousel", "tags": ["#page"], "flags": {} },
  "acf/content-team-list": { "slug": "content/team-list", "tags": ["#page", "#inline"], "flags": {} },
  "acf/content-team-list-item": { "slug": "content/team-list-item", "flags": {} },
  "acf/content-team-list-item-body": { "slug": "content/team-list-item-body", "flags": {} },
  "acf/film-film-grid": { "slug": "film/film-grid", "tags": ["#page"], "flags": {} },
  "acf/film-film-header": { "slug": "film/film-header", "tags": [], "flags": {} },
  "acf/film-latest-films": { "slug": "film/latest-films", "tags": ["#page"], "flags": {} },
  "acf/film-now-playing-bar": { "slug": "film/now-playing-bar", "tags": ["#page"], "flags": {} },
  "acf/film-poster-carousel": { "slug": "film/poster-carousel", "tags": ["#page"], "flags": {} },
  "acf/film-related-films": { "slug": "film/related-films", "tags": ["#page"], "flags": {} },
  "acf/forms-form": { "slug": "forms/form", "tags": ["#page", "#inline"], "flags": {} },
  "acf/forms-newsletter": { "slug": "forms/newsletter", "tags": ["#page"], "flags": {} },
  "acf/forms-newsletter-inner": { "slug": "forms/newsletter-inner", "flags": {} },
  "acf/holding-page-holding-page": { "slug": "holding-page/holding-page", "tags": [], "flags": {} },
  "acf/layout-generic-header": { "slug": "layout/generic-header", "tags": ["#page"], "flags": {} },
  "acf/layout-narrow-content": { "slug": "layout/narrow-content", "tags": ["#page"], "flags": {} },
  "acf/layout-section": { "slug": "layout/section", "flags": {} },
  "acf/layout-spacer": { "slug": "layout/spacer", "tags": ["#page", "#inline"], "flags": {} },
  "acf/layout-text-and-media": { "slug": "layout/text-and-media", "tags": ["#page"], "flags": {} },
  "acf/layout-text-and-media-inner": { "slug": "layout/text-and-media-inner", "flags": {} },
  "acf/layout-two-columns": { "slug": "layout/two-columns", "tags": ["#page"], "flags": {} },
  "acf/layout-two-columns-left": { "slug": "layout/two-columns-left", "flags": {} },
  "acf/layout-two-columns-right": { "slug": "layout/two-columns-right", "flags": {} },
  "acf/media-image-gallery": { "slug": "media/image-gallery", "tags": ["#page"], "flags": {} },
  "acf/media-inline-media": { "slug": "media/inline-media", "tags": ["#page", "#inline"], "flags": {} },
  "acf/media-inline-medias": { "slug": "media/inline-medias", "tags": ["#inline"], "flags": {} },
  "acf/memberships-become-a-member": { "slug": "memberships/become-a-member", "tags": ["#page"], "flags": {} },
  "acf/memberships-become-a-member-inner": { "slug": "memberships/become-a-member-inner", "flags": {} },
  "acf/memberships-membership-grid": {
    "slug": "memberships/membership-grid",
    "tags": ["#page"],
    "flags": { "fullWidth": true },
  },
  "acf/memberships-membership-grid-group": { "slug": "memberships/membership-grid-group", "flags": {} },
  "acf/memberships-membership-grid-group-row": { "slug": "memberships/membership-grid-group-row", "flags": {} },
  "acf/memberships-membership-levels": {
    "slug": "memberships/membership-levels",
    "tags": ["#page"],
    "flags": { "fullWidth": true },
  },
  "acf/news-latest-news": { "slug": "news/latest-news", "tags": ["#page"], "flags": {} },
  "acf/news-news-grid": { "slug": "news/news-grid", "tags": ["#page"], "flags": {} },
  "acf/news-news-header": { "slug": "news/news-header", "tags": [], "flags": {} },
  "acf/programs-program-films": { "slug": "programs/program-films", "flags": {} },
  "acf/programs-program-header": { "slug": "programs/program-header", "flags": {} },
  "acf/programs-program-list": { "slug": "programs/program-list", "tags": ["#page"], "flags": {} },
  "acf/support-donate": { "slug": "support/donate", "tags": ["#page", "#inline"], "flags": {} },
  "acf/support-donate-left": { "slug": "support/donate-left", "flags": {} },
  "acf/support-donate-right": { "slug": "support/donate-right", "flags": {} },
  "acf/support-presented-by": { "slug": "support/presented-by", "flags": {} },
  "acf/support-sponsors": { "slug": "support/sponsors", "tags": ["#page", "#inline"], "flags": {} },
};

blockManifestReader.set(manifest, info);

export default manifest;

if (import.meta.hot) {
  import.meta.hot.accept();
}
